import { PageService } from '../page-service.js';
export class EdgelessPageService extends PageService {
    unmounted() {
        super.unmounted();
        this.selectionManager.set([]);
    }
}
//# sourceMappingURL=edgeless-page-service.js.map